var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Global/search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40815",
    d: "M0 17C0 26.3888 7.61116 34 17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17Z",
    fill: "#EC187B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.9999 24L21.0002 19.9481M21.0002 19.9481C22.1483 18.7869 22.8571 17.1905 22.8571 15.4286C22.8571 11.8782 19.979 9 16.4286 9C12.8782 9 10 11.8782 10 15.4286C10 18.979 12.8782 21.8571 16.4286 21.8571C18.217 21.8571 19.8349 21.1268 21.0002 19.9481Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearch);
export default __webpack_public_path__ + "static/media/global-search.6baa43f239aac28b866f820412cab287.svg";
export { ForwardRef as ReactComponent };